import { NavLink } from "react-router-dom";
import { FaBars, FaHome, FaLock, FaMoneyBill, FaUser } from "react-icons/fa";
import { MdLocalShipping } from "react-icons/md";
import { BiAnalyse, BiSearch } from "react-icons/bi";
import { BiCog } from "react-icons/bi";
import { BiDollarCircle } from "react-icons/bi";
import { BiGroup } from "react-icons/bi";
import { AiFillHeart , AiFillFire } from "react-icons/ai";
import { BsCartCheck } from "react-icons/bs";
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import SidebarMenu from "./SidebarMenu";
import { useTranslation } from "react-i18next";
import AdminAllOrdersHook from "../../hook/admin/AdminAllOrdersHook";
import { useSelector } from "react-redux";




const SideBar = ({ children }) => {


  // const [username,
  //   ,
  //   orderData,
  //   ,
  //   ,
  //   ,
  //   ,
  //   handleSearchDate,
  //   couponSearch,
  //   onChangeCouponSearch,
  //   handleSearchCoupon,
  //   handleRefresh,
  //   loadingDate,
  //   pagination,
  //   getPage] = AdminAllOrdersHook()

  const settingsRes = useSelector((state) => state.settingsReducers.settings);
  //console.log('sidebar')

  const { t } = useTranslation();

  const routes = [
    {
      path: "/",
      name: t("Main"),
      icon: <i className="fa-solid fa-house"></i>,
    },
    {
      path: '/admin/profile',
      name: t("profile"),
      icon: <i className="fa-solid fa-user"></i>,
    },
    {
      path: "/admin/orders",
      name: <div className="d-flex justify-content-end w-100" >
        <div >
          {t("orders")}
        </div>
        <div
          className="mx-2"
          >
        </div>

      </div>,
      icon: <i className="fa-solid fa-box"></i>,
    },
    {
      path: "/admin/alluser",
      name: t("users"),
      icon: <i className="fa-solid fa-users"></i>,
    },
    {
      path: "/reports",
      name: t("product mangement"),
      icon: <i className="fa-solid fa-cubes"></i>,
      exact: true,
      subRoutes: [
        {
          path: "/admin/products?page=1",
          name: t("product"),
          icon: <i className="fa-solid fa-tag"></i>,
        },

        {
          path: "/admin/categories",
          name: t("category"),
          icon: <i className="fa-solid fa-layer-group"></i>,
        },

        {
          path: "/admin/brands",
          name: t("brand"),
          icon: <i className="fa-solid fa-award"></i>,
        },

        {
          path: "/admin/coupons",
          name: t("copon"),
          icon: <i className="fa-solid fa-ticket"></i>,
        },
        {
          path:"/admin/offers",
          name:t("offers"),
          icon: <i className="fa-solid fa-fire"></i>,
        }
        ,
        {
          path:"/admin/excel",
          name:t("excel"),
          icon: <i className="fa-solid fa-file-excel"></i>,
        },
        //drop shipping routes
        {
          path: "/admin/addproductsFromDropShipping?page=1",
          name: t("addProductsDropShippings"),
          icon: <i className="fa-solid fa-truck-fast"></i>,
        },
      ],
    },
    {
      path: "/admin/paymethoudAdmin",
      name: t("payment method"),
      icon: <i className="fa-solid fa-credit-card"></i>,
    },
    {
      path: "/admin/shippingMethod",
      name: t("Shipping Methods"),
      icon: <i className="fa-solid fa-truck"></i>,
    },
     //drop shipping routes
    {
      path: "/admin/dropShippings",
      name: t("DropShippings"),
      icon: <i className="fa-solid fa-parachute-box"></i>,
    },
   

    {
      path: "/admin/ads",
      name: t("ads"),
      icon: <i className="fa-solid fa-bullhorn"></i>,
    },
    {
      path: "/admin/viewslider",
      name: t("image bar"),
      icon: <i className="fa-solid fa-images"></i>,
    },
    {
      path: "/admin/tickets",
      name: t("contact"),
      icon: <i className="fa-solid fa-headset"></i>,
    },
    {
      path: "/reports",
      name: t("Reports"),
      icon: <i className="fa-solid fa-chart-pie"></i>,
      exact: true,
      subRoutes: [
        {
          path: "/admin/cartReport",
          name: t("Abandoned Basket Management"),
          icon: <i className="fa-solid fa-cart-arrow-down"></i>,
        },
        {
          path: "/admin/productSalesReport",
          name: t("Sales Report"),
          icon: <i className="fa-solid fa-chart-line"></i>,
        },
        {
          path: "/admin/googleAnalytics",
          name: t("Google Analytics Report"),
          icon: <i className="fa-brands fa-google"></i>,
        },
      ],
    },
    {
      path: "/reports",
      name: t("fixed page"),
      icon: <i className="fa-solid fa-file-lines"></i>,
      exact: true,
      subRoutes: [
        {
          path: "/admin/terms",
          name: t("Terms & Conditions"),
          icon: <i className="fa-solid fa-scale-balanced"></i>,
        },
        {
          path: "/admin/policy",
          name: t("Refund Policy"),
          icon: <i className="fa-solid fa-shield-halved"></i>,
        },
        {
          path: "/admin/about",
          name: t("About Us"),
          icon: <i className="fa-solid fa-circle-info"></i>,
        },
      ],
    },
    {
      path: "/settings",
      name: t("Settings"),
      icon: <i className="fa-solid fa-gear"></i>,
      exact: true,
      subRoutes: [
        {
          path: "/admin/settings",
          name: t("Site Settings"),
          icon: <i className="fa-solid fa-sliders"></i>,
        },
      ],
    },
  ];
  const [isOpen, setIsOpen] = useState(true);
  const toggle = () => setIsOpen(!isOpen);
  const inputAnimation = {
    hidden: {
      width: 0,
      padding: 0,
      transition: {
        duration: 0.2,
      },
    },
    show: {
      width: "140px",
      padding: "5px 15px",
      transition: {
        duration: 0.2,
      },
    },
  };

  const showAnimation = {
    hidden: {
      width: 0,
      opacity: 0,
      transition: {
        duration: 0.5,
      },
    },
    show: {
      opacity: 1,
      width: "auto",
      transition: {
        duration: 0.5,
      },
    },
  };

  return (
    <>
      <div className="main-container">
        <div 
          className={`sidebarMenu ${isOpen ? "open" : "closed"}`}
          style={{ width: isOpen ? "260px" : "60px", transition: "width 0.3s ease" }}
        >
          <div className="top_section">
            <h1 className="logoMenu" style={{ display: isOpen ? "block" : "none" }}>
              {t("control panal")}
            </h1>
            <div className="bars" onClick={toggle}>
              <i className="fa-solid fa-bars"></i>
            </div>
          </div>

          <section className="routes">
            {routes.map((route, index) => {
              if (route.subRoutes) {
                return (
                  <SidebarMenu
                    key={index}
                    setIsOpen={setIsOpen}
                    route={route}
                    isOpen={isOpen}
                  />
                );
              }

              return (
                <NavLink to={route.path} key={index} className="link">
                  <div className="icon">{route.icon}</div>
                  <div className="link_text" style={{ display: isOpen ? "block" : "none" }}>
                    {route.name}
                  </div>
                </NavLink>
              );
            })}
          </section>
        </div>
        <main style={{ flexGrow: 1, minWidth: 0, overflowX: "hidden" }}>{children}</main>
      </div>
    </>
  );
};

export default SideBar;
